
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "icon-question",
  components: {},
})
export default class IconQuestion extends Vue {
  @Prop() public width!: number;
  @Prop() public height!: number;
  @Prop({ required: false, default: "#000000" }) public color!: string;

  constructor() {
    super();
  }
}
